import React, { useContext } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { Paragraph } from '@fs/zion-ui'
import { usePageTitle } from '../app/PageTitleContext'
import { RelationshipContext } from './relationshipUtils'

export default function RelationshipRawData() {
  usePageView({ page_detail: 'DMConsole:RelationshipRawData' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.relationship.rawData'))
  const relationshipContext = useContext(RelationshipContext)
  const { relationshipData } = relationshipContext.relationshipState

  if (!relationshipData) {
    return null
  }
  return (
    <pre>
      <Paragraph size="sm">{JSON.stringify(relationshipData, null, 4)}</Paragraph>
    </pre>
  )
}
